import produce from 'immer';

import {
  CREATE_SMS_TEMPLATE_FAILURE,
  CREATE_SMS_TEMPLATE_SUCCESS,
  EDIT_SMS_TEMPLATE_FAILURE,
  EDIT_SMS_TEMPLATE_SEQUENCE_FAILURE,
  EDIT_SMS_TEMPLATE_SEQUENCE_SUCCESS,
  EDIT_SMS_TEMPLATE_SUCCESS,
  FETCH_SMS_TEMPLATE_FAILURE,
  FETCH_SMS_TEMPLATE_LIST_FAILURE,
  FETCH_SMS_TEMPLATE_LIST_SUCCESS,
  FETCH_SMS_TEMPLATE_SUCCESS,
} from '@actions/smsTemplate';

const initialState: ISMSTemplateStore = {
  templates: null,
  currentTemplate: null,
  error: null,
};

export default (state: ISMSTemplateStore = initialState, action: any) =>
  produce(state, (draftState: ISMSTemplateStore) => {
    switch (action.type) {
      case FETCH_SMS_TEMPLATE_LIST_SUCCESS:
      case EDIT_SMS_TEMPLATE_SEQUENCE_SUCCESS:
      case CREATE_SMS_TEMPLATE_SUCCESS:
        draftState.templates = Array.isArray(action.response)
          ? action.response
          : [...(draftState.templates || []), action.response];
        draftState.error = null;

        return;

      case FETCH_SMS_TEMPLATE_LIST_FAILURE:
      case EDIT_SMS_TEMPLATE_SEQUENCE_FAILURE:
      case CREATE_SMS_TEMPLATE_FAILURE:
        draftState.error = action.error;

        return;
      case EDIT_SMS_TEMPLATE_SUCCESS:
      case FETCH_SMS_TEMPLATE_SUCCESS:
        draftState.currentTemplate = action.response;
        draftState.error = null;

        return;
      case EDIT_SMS_TEMPLATE_FAILURE:
      case FETCH_SMS_TEMPLATE_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
